import React, { useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useLocalStorage from 'react-localstorage-hook';

export const PatientOutOfContextTab = () => {
  const [, setShouldPublish] = useLocalStorage('shouldPublishPatientOutOfContext', false);

  useEffect(() => {
    setShouldPublish(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePublish = () => setShouldPublish(true);

  return (
    <Accordion id="patientOutOfContextTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>patientOutOfContext</Typography>
        <Button
          id="publish-patient-out-of-context"
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish();
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails />
    </Accordion>
  );
};
